import React from 'react';
import 'semantic-ui-less/semantic.less';
import 'hse-filtering-library-frontend/lib/index.css';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavigationOverlay from '@components/Navigation/NavigationOverlay';
import PageContent from '@pages/PageContent';

function App() {
  return (
    <div className="App">
      <PageContent />
      <NavigationOverlay />
      <ToastContainer />
    </div>
  );
}

export default App;
